import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import bbox from '@turf/bbox';

function AddressSearch({ onSelect, layers }) {
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);

  const api_host = "https://mapgogc2.geopartner.dk";
  const api_user = "api@grunddata";
  const api_key = "c78646f7c717bf265f8e9e0a8a313785";

  const handleTerm = (term) => {
    if (!term) {
      return "";
    }

    let t = term.trimEnd();
    t = t.replace(/ /g, " & ") + ":*";
    return t;
  };

  const searchLayerFeatures = (searchTerm) => {
    if (!layers || layers.length === 0) return [];

    const results = [];
    const lowerSearchTerm = searchTerm.toLowerCase();

    layers.forEach(layer => {
      if (!layer.searchable || !layer.geojson || !layer.geojson.features) return;

      const searchProperty = layer.searchableProperty || 'name';
      
      layer.geojson.features.forEach(feature => {
        const propertyValue = feature.properties[searchProperty];
        if (propertyValue && String(propertyValue).toLowerCase().includes(lowerSearchTerm)) {
          // Calculate center of feature
          const bounds = bbox(feature);
          const longitude = (bounds[0] + bounds[2]) / 2;
          const latitude = (bounds[1] + bounds[3]) / 2;

          results.push({
            label: `${propertyValue} (${layer.searchLabel || 'Layer'})`,
            coordinates: { latitude, longitude },
            source: 'layer'
          });
        }
      });
    });

    return results;
  };

  const handleInputChange = async (event, value) => {
    setInputValue(value);

    if (value) {
      // Search layer features first
      const layerResults = searchLayerFeatures(value);

      // Then search addresses
      let term = handleTerm(value);
      let sql = `SELECT result->>'tekst' tekst, st_transform(ST_PointFromText(CONCAT('POINT(',result->'adresse'->>'x',' ',result->'adresse'->>'y',')'), 25832), 4326) geom from api.mw_adresse_autocomplete WHERE tsvector_adr @@ to_tsquery('${term}') LIMIT 10`;

      try {
        const response = await fetch(`${api_host}/api/v2/sql/${api_user}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=utf-8",
          },
          body: JSON.stringify({
            q: sql,
            key: api_key,
            srs: "4326",
          }),
        });
        const data = await response.json();
        const features = data.features || [];
        const addressOptions = features.map((feature) => {
          const [longitude, latitude] = feature.geometry.coordinates;
          return {
            label: feature.properties.tekst,
            coordinates: { latitude, longitude },
            source: 'address'
          };
        });
        
        // Combine layer results with address results
        setOptions([...layerResults, ...addressOptions]);
      } catch (error) {
        console.error("Error fetching address suggestions:", error);
        setOptions(layerResults);
      }
    } else {
      setOptions([]);
    }
  };

  const handleSelect = (event, value) => {
    if (value && value.coordinates) {
      onSelect(value.coordinates);
    }
  };

  const hasSearchableLayers = layers && layers.some(l => l.searchable);
  const searchLabel = hasSearchableLayers 
    ? layers.find(l => l.searchable)?.searchLabel 
      ? `Søg adresse / ${layers.find(l => l.searchable).searchLabel}`
      : "Søg adresse / data"
    : "Søg efter adresse";

  return (
    <Autocomplete
      freeSolo
      options={options}
      getOptionLabel={(option) => option.label || ""}
      onInputChange={handleInputChange}
      onChange={handleSelect}
      inputValue={inputValue}
      renderInput={(params) => (
        <TextField
          {...params}
          label={searchLabel}
          variant="outlined"
          size="small"
          style={{ backgroundColor: "white" }}
          InputLabelProps={{
            style: { 
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '90%'
            }
          }}
        />
      )}
      style={{ width: 300 }}
    />
  );
}

export default AddressSearch;